import contabilidadListList from "@/modules/contabilidad/components/contabilidadListList.vue";
import contabilidadFormForm from "@/modules/contabilidad/components/contabilidadFormForm.vue";

const routes = [
  {
    path: "/contabilidades",
    name: "Contabilidad List",
    component: contabilidadListList,
    meta: {
      userIsLogged: true,
      label: "t_contabilidad.headers.contabilidadList",
    },
  },
  {
    path: "/orzamentos/:id/editar",
    name: "Contabilidad FormForm",
    component: contabilidadFormForm,
    meta: {
      authority: ["ROLE_ADMIN", "SP_FINANCES"],
      label: "t_contabilidad.headers.update",
    },
  },
  {
    path: "/orzamentos/novo",
    name: "Contabilidad FormCreate",
    component: contabilidadFormForm,
    meta: {
      authority: ["ROLE_ADMIN", "SP_FINANCES"],
      label: "t_contabilidad.headers.create",
    },
  },
];

export default routes;
